import { Injectable, inject } from "@angular/core";
import { isPropertyDefined } from "@recursyve/nice-ts-utils";
import type { NiceAsyncTypeaheadSearchResult } from "@recursyve/nice-ui-kit.v2";
import { NiceAsyncTypeaheadProvider } from "@recursyve/nice-ui-kit.v2";
import type { Observable } from "rxjs";
import { lastValueFrom } from "rxjs";
import { map } from "rxjs/operators";
import { PrimarySystemTypesApi } from "../apis/enums/primary-system-types.api";
import type { PrimarySystemTypes } from "../models/enums/primary-system-types.model";

@Injectable()
export class PrimarySystemTypesTypeaheadApi extends NiceAsyncTypeaheadProvider<PrimarySystemTypes> {
    private readonly api = inject(PrimarySystemTypesApi);

    private readonly pageSize = 20;
    public readonly resource = "primarySystemTypes";

    public override async getById(id: number): Promise<PrimarySystemTypes> {
        return lastValueFrom(this.api.getById(id));
    }

    public override search(
        searchQuery: string,
        page: number
    ): Observable<NiceAsyncTypeaheadSearchResult<PrimarySystemTypes>> {
        return this.api
            .search({
                page,
                pageSize: this.pageSize,
                searchQuery
            })
            .pipe(
                map(items => ({
                    items,
                    nextPage: items.length === this.pageSize ? page + 1 : null
                }))
            );
    }

    public override format(primarySystemType: PrimarySystemTypes): string {
        if (!isPropertyDefined(primarySystemType, "value")) {
            return "";
        }

        if (typeof primarySystemType.value !== "string") {
            return "";
        }

        return primarySystemType.value;
    }
}
